import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { updateVendor, createVendor } from '../api/vendors';
import { deleteUser } from '../api/users';
import { BsPencil, BsPerson, BsBuilding, BsKing, BsFillStarFill,BsFillUsbPlugFill  } from "react-icons/bs";

import StatCard from '../components/StatCard';
import Table from '../components/Table';
import Button from '../components/Button';
import Input from '../components/Input';
import Select from '../components/Select';
import{ useToast } from '../components/Toast/ToastContext';
import UserDialog from '../components/UserDialog';
import UsersAction from '../components/UsersAction';
import VandorDialog from '../components/Dialogs/VandorDialog';
import VendorTabsDialog from '../components/Dialogs/VendorTabsDialog';
import CompanySpecialLinkDialog from '../components/Dialogs/CompanySpecialLinkDialog';
import PageHeaderPortal from '../components/PageHeaderPortal';

export default function VendorsList() {

  const {showToast} = useToast();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [openTabs, setOpenTabs] = useState(false);
  const [suppliersList, setSuppliersList] = useState([]);
  const [selectedSuppliers, setSelectedSuppliers] = useState('');
  const [editing, setEditing] = useState(null);
  const [openLink, setOpenLink] = useState(false);
  const [link, setLink] = useState('');
  const [form, setForm] = useState({
    CompnyName: '',
    CompanyNIP: '',
    CompanyEmail: '',
    CompanyPerson: '',
    CompanyPhone: ''
  });
  const [q, setQ] = useState('');
  const [roleFilter, setRoleFilter] = useState('all');
  const [activeFilter, setActiveFilter] = useState('all');
  const [options, setOptions] = useState({ roles: [], companies: [], users: [], acountsType:[]});
  
 

  const fetchData = async () => {
    setLoading(true);
   Promise.all([
 
  fetch("https://hs2api.razamit.pl/integrationList").then(res => res.json()),
])
  .then(([integracjeData]) => {
    setSuppliersList(
  integracjeData.integracje || [],
    );
  })
  .catch((err) => console.error("Błąd pobierania danych:", err))
  .finally(() => setLoading(false));


    fetch("https://hs2api.razamit.pl/comprole") 
      .then((res) => res.json())
      .then((data) => {
        setOptions((prev) => ({
          ...prev,
          roles: data.roles || [],
          companies: data.companies || [],
          acountsType: data.acountsType || []
        }));
        const mapped = data.companies.map(item => ({
            id: item.id,
            CompnyName: item.CompnyName,              
            CompanyNIP: item.CompanyNIP, 
            CompanyEmail: item.CompanyEmail,
            CompanyPerson: item.CompanyPerson,         
            CompanyPhone: item.CompanyPhone, 
            liczKont: item.liczKont,
            liczLicencje: item.liczLicencje,
            value_for_one: item.value_for_one,
            percent: item.percent,
            at_description: item.at_description,
            at_name: item.at_name,
            atId: item.atId,
            suppliers: item.suppliers,
            secret_tag: item.secret_tag
          }));
       
          setRows(mapped);
      })
      .catch((err) => console.error("Błąd pobierania danych:", err))
      .finally(()=>setLoading(false));
  };

  useEffect(() => { fetchData(); }, []);

  const onEdit = useCallback((row) => {
    setEditing(row);
    setForm({ ...row });
    setOpen(true);
  }, []);

const openLinkCallback = useCallback((row) => {
  console.log(row);
  setLink(row.secret_tag);
  setOpenLink(true);
}, []);

  const onCreate = useCallback(() => {
    setEditing(null);
    setForm({ CompnyName: '', CompanyNIP: '', CompanyEmail: '', CompanyPerson: '', CompanyPhone: '', value_for_one: '', percent: '', value_for_one: '', acount_typeId: ''  });
    setOpen(true);
  }, []);

  const submitForm = useCallback(async () => {
    if (editing) {
      await updateVendor(editing.id, form);
      showToast('Dystrybutor zaktualizowany', 'success');
     
    } else {
      await createVendor(form);
      showToast('Dystrybutor utworzony', 'success');
    }
    setOpen(false);
    fetchData();
  }, [editing,form]);

  const iconMap = {
  Dystrybucja: BsFillUsbPlugFill,
  Zarządzanie: BsFillStarFill,
  Firma: BsBuilding,
  Edycja: BsPencil,
};
 const colorMap = {
      Dystrybucja: 'text-gray-800',
      Zarządzanie: 'text-amber-500',
      Firma: 'text-purple-500',
      Edycja: 'text-orange-500',
    };
  const columns = useMemo(() => ([
      {
        field: 'Count',
        headerName: 'Firma',
        flex: 1,
        renderCell: (params) => {
          const row = params.row;
          const Icon = iconMap[row.at_name] || BsBuilding; // fallback, jeśli brak
 const iconColor = colorMap[row.at_name] || 'text-gray-400';
          return (
            <div className="flex items-center gap-2">
        {/* Ikona po lewej */}
        <Icon className={`${iconColor} w-5 h-5 flex-shrink-0`} />

        {/* Tekst obok w kolumnie */}
        <div className="flex flex-col leading-tight">
          <span className="font-medium text-gray-900">{row.CompnyName}</span>
          <span className="text-gray-400 text-xs">Typ: {row.at_name}</span>
        </div>
      </div>
          );
        }
      },
    {
        field: 'Count',
        headerName: 'Licznik',
        flex: 1,
        renderCell: (params) => {
          const row = params.row;
          return (
            <div className="flex flex-col">
              <span className="text-gray-900">Kont: {row.liczKont}</span>
              <span className="text-gray-900 ">Licencji: {row.liczLicencje}</span>
            </div>
          );
        }
      },
    { field: 'CompanyNIP', headerName: 'NIP', width: 150 },

    { field: 'CompanyEmail', headerName: 'Email' },
    { field: 'CompanyPerson', headerName: 'Osoba'  },
    { field: 'CompanyPhone', headerName: 'Numer'  },
    { field: 'value_for_one', headerName: 'Prowizja %'  },
    { field: 'percent', headerName: 'Marketing %'  },

    {
      field: 'actions', headerName: 'Akcje', sortable: false, renderCell: (params) => (
        <div className="flex gap-2">
                  <UsersAction row={params.row}  onEdit={onEdit} onOpenLink={openLinkCallback} />

      </div>
      )
    }
  ]), [onEdit, openLinkCallback]);

  const filteredRows = useMemo(() => {
    const term = q.trim().toLowerCase();
    return rows.filter(u => {
      const byTerm = !term || u.CompanyPerson.toLowerCase().includes(term) || u.CompanyPhone.toLowerCase().includes(term) || u.CompanyNIP.toLowerCase().includes(term) || u.CompnyName.toLowerCase().includes(term) || u.CompanyEmail.toLowerCase().includes(term);
    //  const byRole = roleFilter === 'all' || u.role === roleFilter;
     // const byActive = activeFilter === 'all' || String(u.active) === activeFilter;
      return byTerm;
    });
  }, [rows, q, roleFilter, activeFilter]);

  const total = rows.length;
  const activeCount = rows.filter(r => r.active).length;
  const managers = rows.filter(r => r.role === 'manager').length;
  const usersCount = rows.filter(r => r.role === 'user').length;

  return (
    <div>
      <PageHeaderPortal
        title="Dystrybutorzy aplikacji"
        subtitle="Konta dystrybutorów aplikacji HShop"
        actions={(
          <Button variant="contained" onClick={onCreate} size="medium" className="w-full sm:w-auto">
            Dodaj dystrybutora
          </Button>
        )}
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mb-3">
        <StatCard label="Dystrybutorzy" value={total} color="blue" />
   
      </div> 

      <div className="w-full rounded-sm bg-white p-3 sm:p-4 lg:p-5 border border-gray-200 mb-3">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3 w-full sm:max-w-3xl">
            <Input label="Szukaj" value={q} onChange={e => setQ(e.target.value)} size="small" fullWidth placeholder="Imię, nazwisko, firma, email, NIP..." />
       
          </div>
          <div className="flex gap-2">
            <Button variant="outlined" onClick={() => { setQ(''); setRoleFilter('all'); setActiveFilter('all'); }}>Wyczyść</Button>
          </div>
        </div>
      </div>

      <div className="rounded-sm overflow-hidden border border-gray-200">
        <Table 
          columns={columns} 
          data={filteredRows} 
          loading={loading}
        />
      </div>

      {/* <VandorDialog
  open={open}
  editing={editing}
  form={form}
  setForm={setForm}
  options={options}
  onClose={() => setOpen(false)}
  onSubmit={submitForm}
/> */}

<VendorTabsDialog
  open={open}
  editing={editing}
  form={form}
  setForm={setForm}
  options={options}
  onClose={() => setOpen(false)}
  onSubmit={submitForm}
  suppliersList={suppliersList}
  selectedSuppliers={selectedSuppliers}
/>
    
    <CompanySpecialLinkDialog open={openLink} setOpen={setOpenLink} link={link} />
    </div>
  );
}
